import { Link } from 'react-router-dom';
import { Img } from 'react-image';
import { Navbar } from 'flowbite-react';
import { useThemeContext } from 'src/context/ThemeProvider';

const InterviewEndedScreen = () => {
	const { themeMode } = useThemeContext();
	return (
		<div className="h-screen w-screen dark:text-white">
			<Navbar
				className={`w-full rounded-none !px-[45px] sm:!px-[10px] bg-white dark:bg-[#18222D]`}
				fluid={true}
				rounded={true}
			>
				<div className="flex items-center gap-8 ">
					<Link to="/" className="flex items-center ">
						<Img
							loading="lazy"
							src={
								themeMode === 'dark'
									? 'https://masai-website-images.s3.ap-south-1.amazonaws.com/level_Up_By_Masai_Icon_Dark_a5f53496b9.svg'
									: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/level_Up_By_Masai_Icon_Dark_a5f53496b9.svg'
							}
							width="110"
							height="32px"
							alt="LevelUp Logo"
						/>
					</Link>
				</div>
			</Navbar>
			<div className="my-60 flex flex-col items-center justify-center gap-2 dark:text-white">
				<p className=" text-2xl font-bold">Technical round has ended</p>
				<p className=" text-base">The meeting has ended by the interviewer.</p>
			</div>
		</div>
	);
};

export default InterviewEndedScreen;
